/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Optout_QInputs */



/**
* | output |
* | --- |
* | "Does a member who opts out keep their level?" |
*
* @param {Products_Leveling_Faq_Optout_QInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_optout_q = /** @type {((inputs?: Products_Leveling_Faq_Optout_QInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Optout_QInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранит ли уровень участник, который отказался от учёта?")
	return /** @type {LocalizedString} */ ("Does a member who opts out keep their level?")
});